module.exports = __webpack_public_path__ + "img/gallery-13.0937c6ca.jpg";